(function () {
  'use strict';


  /* =========================================================
     DEVICE
  ========================================================= */

  function supportsHover() {
    return (
      window.matchMedia &&
      window
        .matchMedia(
          '(hover: hover) and (pointer: fine)'
        )
        .matches
    );
  }


  /* =========================================================
     CREATE VIDEO
  ========================================================= */

  function buildVideo(src) {

    const video =
      document.createElement('video');


    video.className =
      'quad-tile__video-el';


    /*
      Critical for mobile autoplay.
    */

    video.muted = true;

    video.defaultMuted = true;

    video.loop = true;

    video.playsInline = true;

    video.autoplay = true;


    /*
      Load video early enough to avoid a visible delay when
      the card reaches the central viewport area.
    */

    video.preload = 'auto';


    /*
      Safari / iOS attributes.
    */

    video.setAttribute(
      'muted',
      ''
    );

    video.setAttribute(
      'autoplay',
      ''
    );

    video.setAttribute(
      'playsinline',
      ''
    );

    video.setAttribute(
      'webkit-playsinline',
      ''
    );


    /*
      Direct MP4 URL.
    */

    video.src = src;


    return video;
  }


  /* =========================================================
     VIDEO CONTROLLER
  ========================================================= */

  function createVideoController(tile) {

    const holder =
      tile.querySelector(
        '[data-hover-video]'
      );


    if (!holder) {
      return null;
    }


    const src =
      holder.getAttribute(
        'data-video-src'
      );


    if (!src) {
      return null;
    }


    let video = null;

    let mounted = false;

    let wantsToPlay = false;



    /* =======================================================
       SHOW VIDEO ONLY WHEN ACTUALLY PLAYING
    ======================================================= */

    function setPlaying() {

      tile.classList.add(
        'video-is-playing'
      );

    }



    /* =======================================================
       HIDE VIDEO
    ======================================================= */

    function setNotPlaying() {

      tile.classList.remove(
        'video-is-playing'
      );

    }



    /* =======================================================
       TRY PLAY
    ======================================================= */

    function attemptPlay() {

      if (
        !video ||
        !wantsToPlay
      ) {
        return;
      }


      video.muted = true;

      video.defaultMuted = true;


      const playPromise =
        video.play();


      if (
        playPromise &&
        typeof playPromise.catch ===
          'function'
      ) {

        playPromise.catch(
          function () {

            /*
              If autoplay is temporarily blocked,
              keep the original image visible.
            */

            setNotPlaying();

          }
        );

      }

    }



    /* =======================================================
       MOUNT VIDEO
    ======================================================= */

    function mount() {

      if (
        mounted &&
        video
      ) {
        return video;
      }


      video =
        buildVideo(src);



      /*
        Browser confirms real video playback.
      */

      video.addEventListener(
        'playing',
        setPlaying
      );



      /*
        Retry as soon as enough data exists.
      */

      video.addEventListener(
        'loadeddata',
        function () {

          if (wantsToPlay) {
            attemptPlay();
          }

        }
      );


      video.addEventListener(
        'canplay',
        function () {

          if (wantsToPlay) {
            attemptPlay();
          }

        }
      );



      /*
        Never show an empty holder on errors.
      */

      video.addEventListener(
        'error',
        function () {

          setNotPlaying();

        }
      );



      holder.appendChild(video);


      mounted = true;


      /*
        Explicitly start fetching.
      */

      try {

        video.load();

      } catch (error) {

        /*
          Safe fallback.
        */

      }


      return video;
    }



    /* =======================================================
       PLAY
    ======================================================= */

    function play() {

      wantsToPlay = true;


      mount();


      attemptPlay();
    }



    /* =======================================================
       PAUSE
    ======================================================= */

    function pause() {

      wantsToPlay = false;


      setNotPlaying();


      if (!video) {
        return;
      }


      try {

        video.pause();

      } catch (error) {

        /*
          Ignore browser-specific pause errors.
        */

      }

    }



    /* =======================================================
       RESET
    ======================================================= */

    function reset() {

      wantsToPlay = false;


      setNotPlaying();


      if (!video) {
        return;
      }


      try {

        video.pause();

      } catch (error) {

      }


      try {

        video.currentTime = 0;

      } catch (error) {

        /*
          Safari might not allow seeking before metadata.
        */

      }

    }



    return {

      mount: mount,

      play: play,

      pause: pause,

      reset: reset

    };

  }


  /* =========================================================
     DESKTOP
  ========================================================= */

  function initDesktopTile(tile) {

    const controller =
      createVideoController(tile);


    if (!controller) {
      return;
    }



    /*
      Start video on hover.
    */

    tile.addEventListener(
      'mouseenter',
      function () {

        controller.play();

      }
    );



    /*
      Reset when mouse leaves.
    */

    tile.addEventListener(
      'mouseleave',
      function () {

        controller.reset();

      }
    );



    /*
      Keyboard accessibility.
    */

    tile.addEventListener(
      'focusin',
      function () {

        controller.play();

      }
    );


    tile.addEventListener(
      'focusout',
      function () {

        controller.reset();

      }
    );

  }


  /* =========================================================
     MOBILE PRELOAD

     Load the video shortly before the tile reaches the
     central viewport.

     This greatly reduces the delay on iPhone.
  ========================================================= */

  function createPreloadObserver(
    tiles,
    controllers
  ) {

    const observer =
      new IntersectionObserver(

        function (entries) {

          entries.forEach(
            function (entry) {

              if (
                !entry.isIntersecting
              ) {
                return;
              }


              const controller =
                controllers.get(
                  entry.target
                );


              if (controller) {

                controller.mount();

              }


              /*
                Only preload once.
              */

              observer.unobserve(
                entry.target
              );

            }
          );

        },

        {

          root: null,

          /*
            Start loading before the card reaches
            the visible central area.
          */

          rootMargin:
            '70% 0px 70% 0px',

          threshold: 0

        }

      );


    tiles.forEach(
      function (tile) {

        observer.observe(tile);

      }
    );


    return observer;
  }


  /* =========================================================
     MOBILE ACTIVE AREA
  ========================================================= */

  function createMobileActiveObserver(
    tiles,
    controllers
  ) {

    const observer =
      new IntersectionObserver(

        function (entries) {

          entries.forEach(
            function (entry) {

              const tile =
                entry.target;


              const controller =
                controllers.get(tile);



              /* =============================================
                 ENTER ACTIVE AREA
              ============================================= */

              if (
                entry.isIntersecting
              ) {

                tile.classList.add(
                  'is-mobile-active'
                );


                /*
                  Images animate through CSS.

                  Videos start playing here.
                */

                if (controller) {

                  controller.play();

                }

              }



              /* =============================================
                 LEAVE ACTIVE AREA
              ============================================= */

              else {

                tile.classList.remove(
                  'is-mobile-active'
                );


                tile.classList.remove(
                  'video-is-playing'
                );


                if (controller) {

                  controller.pause();

                }

              }

            }
          );

        },

        {

          root: null,


          /*
            Central zone.

            The animation activates once the card has
            meaningfully entered the screen.
          */

          rootMargin:
            '-15% 0px -15% 0px',

          threshold: 0.25

        }

      );


    tiles.forEach(
      function (tile) {

        observer.observe(tile);

      }
    );


    return observer;
  }


  /* =========================================================
     MOBILE
  ========================================================= */

  function initMobileTiles(section) {

    const tiles =
      Array.from(
        section.querySelectorAll(
          '.quad-tile'
        )
      );


    if (!tiles.length) {
      return;
    }


    const controllers =
      new Map();



    /*
      Create one controller per tile.
    */

    tiles.forEach(
      function (tile) {

        controllers.set(
          tile,
          createVideoController(tile)
        );

      }
    );



    /*
      Preload nearby videos.
    */

    section._quadPreloadObserver =
      createPreloadObserver(
        tiles,
        controllers
      );



    /*
      Activate transition near the center.
    */

    section._quadMobileObserver =
      createMobileActiveObserver(
        tiles,
        controllers
      );

  }


  /* =========================================================
     SECTION INITIALIZATION
  ========================================================= */

  function initSection(section) {

    if (!section) {
      return;
    }


    /*
      Prevent duplicate initialization.
    */

    if (
      section.dataset
        .quadInitialized === 'true'
    ) {
      return;
    }


    section.dataset
      .quadInitialized = 'true';



    const tiles =
      section.querySelectorAll(
        '.quad-tile'
      );


    if (!tiles.length) {
      return;
    }



    /*
      Desktop.
    */

    if (supportsHover()) {

      tiles.forEach(
        function (tile) {

          initDesktopTile(tile);

        }
      );

    }



    /*
      Mobile / touch.
    */

    else {

      initMobileTiles(section);

    }

  }


  /* =========================================================
     INIT ALL SECTIONS
  ========================================================= */

  function initAll() {

    document
      .querySelectorAll(
        '.quad-grid'
      )
      .forEach(
        function (section) {

          initSection(section);

        }
      );

  }


  /* =========================================================
     PAGE LOAD
  ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector(
          '.quad-grid'
        ) ||
        (
          event.target.classList &&
          event.target.classList.contains(
            'quad-grid'
          )
            ? event.target
            : null
        );


      if (!section) {
        return;
      }


      section.dataset
        .quadInitialized = 'false';


      initSection(section);

    }
  );

})();